import apiUser from '@/api/user';

export default {
  name: 'RewardsHistoryRow',
  props: {
    reward: Object
  },
  data: function() {
    return {
      userName: ''
    };
  },
  computed: {
    getType: function() {
      if (this.reward.rewardCount >= 10) {
        return 'Profile';
      }
      return 'Chat';
    },
    getDemand: function() {
      if (this.reward.demandLevel) {
        return this.reward.demandLevel;
      }
      return 'Normal';
    }
  },
  created: async function() {
    const { senderUserId } = this.reward;
    const { firstName, lastName } = await apiUser.getUser(senderUserId);
    this.userName = `${firstName} ${lastName}`;
  }
};
